import { render, staticRenderFns } from "./CardDock.vue?vue&type=template&id=62fefeba&"
import script from "./CardDock.vue?vue&type=script&lang=js&"
export * from "./CardDock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports